
class CapSelectRequestingDistrict {
  constructor(config) {
    this.canSelectRequestingDistrict = config['select_requesting_district']
  }

  // eslint-disable-next-line
  checkPermission(options = {}) {
    return this.canSelectRequestingDistrict
  }
}

function key() {
  return 'select_requesting_district'
}

function create(config) {
  return new CapSelectRequestingDistrict(config)
}

export default {
  key,
  create,
}
